namespace appn.views.data.viewEntry {

    class InitArgs {
        entryId: string = emptyString; // Guid
        exportSingleEntry: string = emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs) {
        _initArgs = args;
        addEvents();
    }

    function addEvents() {
        // Refresh the page if changes were made in modal
        $(document).on('hidden.bs.modal', function() {
            if (iframe.getHost().reloadFlag)
                appn.location.reloadCurrentPage();
        });

        $('#btnprint').on('click', function(e) {
            e.preventDefault();
            window.print();
        });

        $('#btnexport').on('click', function(e) {
            e.preventDefault();

            const params = appn.location.buildQueryString([{ name: 'id', value: _initArgs.entryId }]);
            let updateNotificationTotal = appn.notifications.updateNotificationTotal;
            if (utils.hasValue(window.opener))
                updateNotificationTotal = window.opener.appn.notifications.updateNotificationTotal;

            appn.ajax.post({
                url: _initArgs.exportSingleEntry + params,
                data: $('#exportForm').serialize(),
                done: function() {
                    if (updateNotificationTotal) {
                        if (utils.hasValue(window.opener))
                            updateNotificationTotal.call(window.opener);
                        else 
                            updateNotificationTotal.call(window);
                    }

                    ui.showExportConfirmation('Form Entry');
                },
                fail: function() {
                    appn.toast.notify(toast.Type.error, T('Form Entry failed.'));
                }
            });
        });

        $('.btn-removeFieldNames').on('click', function(e) {
            e.preventDefault();
            $('.text-muted').remove();
            $(this).remove();
        });

    }
}
